import { withInstall } from '@element-plus/utils/with-install'
import { ConfigProvider } from './config-provider'

export const ElConfigProvider = withInstall(ConfigProvider)
export default ElConfigProvider
